import React, { useEffect, useState } from "react";
import { getChaptersData, getTesstParameter, getTopicsData } from "../../../../actions/feedActions";
import "./chaptersAccordion.scss";
import yTubeIcon from "../../../../public/images/youtubeIcon.svg";

const ChaptersAccordion = (props) => {
  const [chaptersData, setchaptersData] = useState([]);
  const [topicsData, settopicsData] = useState([]);
  const [topicVideos, settopicVideos] = useState([]);
  const [loading, setloading] = useState(true);
  const [worksheet, setworksheet] = useState([]);

  useEffect(() => {
    getChaptersData(props.programId, props.studentId)
      .then((res) => {
        debugger;
        setchaptersData(res.data.result.assessments);
        setloading(false);
      })
      .catch((err) => {
        debugger;
      });
  }, []);

  const getTopicFunc = (assessmentId) => {
    getTopicsData(props.programId, props.studentId, assessmentId)
      .then((res) => {
        debugger;
        settopicsData(res.data.result);
        settopicVideos(res.data.videos);
        setworksheet(res.data.worksheets);
      })
      .catch((err) => {
        debugger;
      });
  };

  const redirectToTest = (testId, chapterId, programId, studentId) => {
    debugger;
    getTesstParameter(testId, studentId)
      .then((res) => {
        window.open(
          `https://dashboard.lincolnmethod.com/signin?continue_session=true&student_id=${studentId}&program=${programId}&test_taken=${res.data}&testid=${testId}&assessid=${chapterId}&practice=0&txt_program=${programId}&referrer=feeds`,
          "_blank"
        );
        debugger;
      })
      .catch((err) => {});
  };
  console.log("Chapters Data", chaptersData);
  console.log("Topics Data", topicsData);
  console.log("Topics Videos", topicVideos);
  console.log("Worksheets", worksheet);
  return (
    <div className="chaptersAccordion">
      {loading ? (
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div id={`accordion${props.programId}`} className="myaccordion" style={{ margin: 0 }}>
          {chaptersData.map((item, index) => (
            <div className="card" key={index}>
              <div className="card-header" id="headingOne">
                <h2 className="mb-0">
                  <div
                    className="row d-flex align-items-center justify-content-between btn btn-link collapsed"
                    data-toggle="collapse"
                    data-target={`#One${index}`}
                    aria-expanded="true"
                    aria-controls="collapseOne"
                    onClick={() => getTopicFunc(item.assessment_id)}
                  >
                    <div className="col-md-8 col-6 text-left">
                      <label style={{ fontSize: 14 }}>{item.name}</label>
                    </div>

                    <div className="col-md-4 col-2 text-right">
                      <span className="fa-stack fa-sm">
                        <i className="fas fa-circle fa-stack-2x"></i>
                        <i className="fas fa-plus fa-stack-1x fa-inverse"></i>
                      </span>
                    </div>
                  </div>
                </h2>
              </div>
              <div
                id={`One${index}`}
                className="collapse"
                aria-labelledby="headingOne"
                data-parent={`#accordion${props.programId}`}
              >
                <div className="card-body" style={{ backgroundColor: "#F7F6F6", padding: "10px" }}>
                  {Object.keys(topicsData).map((topics, index2) => (
                    <React.Fragment>
                      {topicsData[topics]["beforeScore"] == "0" ? (
                        <div className="d-flex justify-content-between mt-2">
                          <label>{topicsData[topics]["testname"]}</label>
                          <div>
                            <button
                              className="startTestBtn"
                              onClick={() =>
                                redirectToTest(
                                  topicsData[topics]["testid"],
                                  item?.id,
                                  item?.prog_id,
                                  props.studentId
                                )
                              }
                            >
                              {/* <a
                                target="__blank"
                                href={`https://dashboard.lincolnmethod.com/signin?continue_session=true&student_id=${props.studentId}&prog_id=${props.programId}&assess_id=${item.assessment_id}&test_id=${topicsData[topics]["testid"]}`}
                                className=""
                              > */}
                              Start test
                              {/* </a> */}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div id="myGroup">
                          <div className="row">
                            <div className="col-12">
                              <label>{topicsData[topics]["testname"]}</label>
                            </div>
                            <div className="col-12">
                              <div className="d-flex justify-content-around">
                                <div
                                  data-toggle="collapse"
                                  data-target={`#worksheetCollapse${index2}`}
                                  aria-expanded="false"
                                  aria-controls="collapseExample"
                                  style={{ cursor: "pointer" }}
                                  data-parent="#myGroup"
                                >
                                  <i
                                    className="fas fa-file mr-2"
                                    style={{ color: "#FFC43D", fontSize: 20 }}
                                  ></i>{" "}
                                  <label
                                    style={{ color: "#FFC43D" }}
                                    className="mr-3 d-none d-sm-inline"
                                  >
                                    Worksheet
                                  </label>{" "}
                                </div>
                                <div
                                  data-toggle="collapse"
                                  data-target={`#collapseExample${index2}`}
                                  aria-expanded="false"
                                  aria-controls={`worksheetCollapse${index2}`}
                                  style={{ cursor: "pointer" }}
                                  data-parent="#myGroup"
                                >
                                  <i
                                    className="fas fa-play-circle mr-2"
                                    style={{ color: "#EF476F", fontSize: 20 }}
                                  ></i>
                                  <label
                                    style={{ color: "#EF476F" }}
                                    className="mr-3 d-none d-sm-inline"
                                  >
                                    Watch & Learn
                                  </label>{" "}
                                </div>
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    redirectToTest(
                                      topicsData[topics]["testid"],
                                      item?.id,
                                      item?.prog_id,
                                      props.studentId
                                    )
                                  }
                                >
                                  <i
                                    className="fas fa-redo mr-2"
                                    style={{ color: "#1B9AAA", fontSize: 20 }}
                                  ></i>
                                  <label
                                    style={{ color: "#1B9AAA" }}
                                    className="mr-3 d-none d-sm-inline"
                                  >
                                    Re-do
                                  </label>{" "}
                                </div>
                                <div className="score">
                                  <label style={{ color: "#218838" }} className="mr-2">
                                    Score
                                  </label>{" "}
                                  <label className="percent">
                                    {topicsData[topics]["beforeScore"]}%
                                  </label>{" "}
                                </div>
                              </div>
                              <div class="accordion-group">
                                <div class="collapse" id={`collapseExample${index2}`}>
                                  <div class="card card-body">
                                    <label className="text-dark">
                                      Watch these suggested videos to improve even further:{" "}
                                    </label>
                                    {topicVideos &&
                                      topicVideos[topicsData[topics]["testid"]] &&
                                      topicVideos[topicsData[topics]["testid"]].map(
                                        (videos, videoKey) => (
                                          <a
                                            target="__blank"
                                            key={videoKey}
                                            href={videos.video_url}
                                          >
                                            <img className="mr-3" src={yTubeIcon} />
                                            {videos.video_caption}
                                          </a>
                                        )
                                      )}
                                  </div>
                                </div>
                                <div class="collapse" id={`worksheetCollapse${index2}`}>
                                  <div class="card card-body">
                                    <label className="text-dark">Worksheet:</label>
                                    {worksheet &&
                                      worksheet[topicsData[topics]["testid"]] &&
                                      worksheet[topicsData[topics]["testid"]].map(
                                        (videos, videoKey) =>
                                          videos.is_s3 === 0 ? (
                                            <a
                                              key={videoKey}
                                              target="__blank"
                                              href={`https://dashboard.lincolnmethod.com/uploads/worksheets/${videos.file_name}`}
                                            >
                                              <i className="fas fa-file-word mr-3 text-dark" />
                                              {videos.file_label}
                                            </a>
                                          ) : (
                                            <a
                                              key={videoKey}
                                              target="__blank"
                                              href={`https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/${videos.file_name}`}
                                            >
                                              <i className="fas fa-file-word mr-3 text-dark" />
                                              {videos.file_label}
                                            </a>
                                          )
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <hr />
                    </React.Fragment>
                  ))}
                  {/* <div className="row">
                    <div className="col-12">
                      <label>Use: Coordinating Conjunctions</label>
                    </div>
                    <div className="col-12 text-right">
                      <div className="d-flex justify-content-around">
                        <div>
                          <i
                            className="fas fa-file mr-2"
                            style={{ color: "#FFC43D", fontSize: 20 }}
                          ></i>{" "}
                          <label
                            style={{ color: "#FFC43D" }}
                            className="mr-3 d-none d-sm-inline"
                          >
                            Worksheet
                          </label>{" "}
                        </div>
                        <div>
                          <i
                            className="fas fa-play-circle mr-2"
                            style={{ color: "#EF476F", fontSize: 20 }}
                          ></i>
                          <label
                            data-toggle="collapse"
                            data-target="#collapseExample"
                            aria-expanded="false"
                            aria-controls="collapseExample"
                            style={{ color: "#EF476F" }}
                            className="mr-3 d-none d-sm-inline"
                          >
                            Watch & Learn
                          </label>{" "}
                        </div>
                        <div>
                          <i
                            className="fas fa-redo mr-2"
                            style={{ color: "#1B9AAA", fontSize: 20 }}
                          ></i>
                          <label
                            style={{ color: "#1B9AAA" }}
                            className="mr-3 d-none d-sm-inline"
                          >
                            Re-do
                          </label>{" "}
                        </div>
                        <div className="score">
                          <label style={{ color: "#218838" }} className="mr-2">
                            Score
                          </label>{" "}
                          <label className="percent">55%</label>{" "}
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* <div
              id={`One${index}`}
              className="collapse"
              aria-labelledby="headingOne"
              data-parent={`#accordion${props.programId}`}
            >
              <div
                className="card-body"
                style={{ backgroundColor: "#F7F6F6", padding: 10 }}
              >
                <div className="d-flex justify-content-between mt-2">
                  <label>Use: Coordinating Conjunctions</label>
                  <div>
                    <button className="startTestBtn">Start test</button>
                  </div>
                </div>
                <hr />
                <div className="d-flex justify-content-between mt-2">
                  <label>Identify: Coordinating Conjunctions</label>
                  <div>
                    <button className="startTestBtn">Start test</button>
                  </div>
                </div>
                <hr />
                <div className="d-flex justify-content-between mt-2">
                  <label>Identify: Subordinating Conjunctions</label>
                  <div>
                    <button className="startTestBtn">Start test</button>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-12">
                    <label>Use: Correct Pair of Correlative Conjunctions</label>
                  </div>
                  <div className="col-12 text-right">
                    <i
                      className="fas fa-file"
                      style={{ color: "#FFC43D", fontSize: 20 }}
                    ></i>{" "}
                    <label style={{ color: "#FFC43D" }} className="mr-3">
                      Worksheet
                    </label>{" "}
                    <i
                      className="fas fa-play-circle"
                      style={{ color: "#EF476F", fontSize: 20 }}
                    ></i>
                    <label
                      data-toggle="collapse"
                      data-target="#collapseExample"
                      aria-expanded="false"
                      aria-controls="collapseExample"
                      style={{ color: "#EF476F" }}
                      className="mr-3"
                    >
                      Watch & Learn
                    </label>{" "}
                    <i
                      className="fas fa-redo mr-1"
                      style={{ color: "#1B9AAA", fontSize: 20 }}
                    ></i>
                    <label style={{ color: "#1B9AAA" }} className="mr-3">
                      Re-do
                    </label>{" "}
                    <label style={{ color: "#218838" }} className="mr-1">
                      Score
                    </label>{" "}
                    <label className="score">55%</label>{" "}
                    
                  </div>
                </div>
                <hr />
                <div className="d-flex justify-content-between mt-2">
                  <label>Fill in the Missing Correlative Conjunction</label>
                  <div>
                    <button className="startTestBtn">Start test</button>
                  </div>
                </div>
              </div>
            </div> */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChaptersAccordion;
